<div class="background">
  <div class="gradient">
    <div class="container">
      <h1>{{ 'ait.title.long' | translate }}</h1>
      <div class="actions">
        <br>
        <span [ngClass]="routeAnimationsElements">{{ 'ait.about.tagline' | translate }}</span>
        <br>
      </div>
    </div>
    <div class="container">
      <div class="follow-releases" [ngClass]="routeAnimationsElements">
        <h2 rtl>{{ 'ait.about.all-your-software.title' | translate }}</h2>
        <p rtl>
          {{ 'ait.about.all-your-software.description' | translate }}
        </p>
    
        <img [src]="licences" alt="Licenses list example">
      </div>
      <div class="follow-releases" [ngClass]="routeAnimationsElements">
        <h2 rtl>{{ 'ait.about.get-notified.title' | translate }}</h2>
        <p rtl>
          {{ 'ait.about.get-notified.description' | translate }}
        </p>
      </div>
      <div class="follow-releases" [ngClass]="routeAnimationsElements">
        <h2 rtl>{{ 'ait.about.secure-access.title' | translate }}</h2>
        <p rtl>
          {{ 'ait.about.secure-access.description' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>